const serviceEvents = {
  getAvailableRoles: "RoleService:getAvailableRoles",
  sessionLogout: "SessionGuard:sessionLogout",
  sessionWarning: "SessionGuard:sessionWarning",
  sessionStarted: "SessionGuard:sessionStarted",
};

export { serviceEvents as ServiceEvents };
